var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{attrs:{"id":"marketing-container"}},[_c('el-aside',{staticStyle:{"background-color":"black"},attrs:{"width":"50px"}},[_c('navigation')],1),_vm._v(" "),_c('el-container',[_c('el-main',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }